module.exports = __webpack_public_path__ + "static/media/pin.61cc5774.svg";